import React, { useContext } from 'react';

import { CustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';
import { CustomsCurrencyInput } from '../customs-currency-input';
import { messages } from '../messages';
import { Unknown } from '../../../../constants/currency-codes';

export const CustomsPostagePaid = () => {
  const { defaultCurrencyCode, postagePaid, updatePostagePaid }: CustomsContextValue = useContext(CustomsContext);

  const verifiedPostagePaidValue = postagePaid?.value || 0;
  const verifiedPostagePaidCode = postagePaid?.code && postagePaid?.code !== Unknown ? postagePaid.code : defaultCurrencyCode;

  return (
    <CustomsCurrencyInput
      currencyInputCode={verifiedPostagePaidCode}
      currencyInputLabel={messages.postagePaidLabel}
      initialCurrencyInputValue={verifiedPostagePaidValue}
      updateCurrencyValue={updatePostagePaid}
    />
  );
};
